<template>
	<div class="controls">
		<button class="button small prev" @click="$parent.back()" :disabled="disabledPrev">
			<img src="images/icons/arrow-back.svg" />
		</button>

		<button class="button large disagree" @click="$parent.decide(false)">
			<img src="images/icons/thumb-down.svg" />
		</button>

		<button class="button large agree" @click="$parent.decide(true)">
			<img src="images/icons/thumb-up.svg" />
		</button>

		<button class="button small next" @click="$parent.next()" :disabled="disabledNext">
			<img src="images/icons/arrow-next.svg" />
		</button>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	computed: {
		...mapState({
			currentStatementIndex: (state) => state.currentStatementIndex
		}),

		...mapGetters(['disabledNext', 'disabledPrev']),

		statementID() {
			return this.$route.params.id
		}
	}
}
</script>

<style lang="scss" scoped>
.controls {
	color: white;
	display: flex;
	align-items: center;
	user-select: none;
}

.button {
	border-radius: 100px;
	margin: 0 5px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: transform 0.1s;
	border: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	padding: 0;

	&:active {
		transform: scale(0.9);
	}

	&.large {
		width: 70px;
		height: 70px;
	}

	&.small {
		width: 40px;
		height: 40px;
	}

	&.disagree {
		background: $red;
	}

	&.agree {
		background: $green;
	}

	&.prev,
	&.next {
		background: rgba(255, 255, 255, 0.4);
	}

	&[disabled] {
		opacity: 0.5;
		pointer-events: none;
	}

	img {
		width: 50%;
		height: 50%;
		object-fit: contain;
		object-position: center;
	}
}
</style>
